export default function isLitHTML(val){ return val && val['_$litType$'] }